<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="添加首页横幅" name="1">
      <FirBannerAdd :updataID='updataID'></FirBannerAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 首页横幅修改修改
 */
import FirBannerAdd from '../../../../static/form/FirBannerAdd.vue'
export default {
  components: {
    FirBannerAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/FirInfo'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/FirBannerUpdate.vue